import React from "react";
import PrimaryBtn from "../app/buttons";
import Upload from "../../assets/icons/upload.svg";
import AddIcon from "../../assets/icons/add.svg";
import { FaChevronLeft } from "react-icons/fa";
import { useNavigate } from "react-router";

const Header = ({ text = "", btn1Text, btn2Text, handleModal, handleAdd }) => {
  return (
		<div>
			<div className="h-20 flex w-full items-center justify-between">
				<h2 className="text-2xl font-bold text-da-gray-600 capitalize">
					{text || "Overview"}
				</h2>
				<div className="flex gap-6 items-center">
					{handleModal && (
						<PrimaryBtn
							color={"#3787FF"}
							onClick={handleModal}
							icon={Upload}
							text={btn1Text}
							bg={"transparent"}
							className="border border-da-blue-100"
						/>
					)}
					{handleAdd && (
						<PrimaryBtn
							color={"white"}
							onClick={handleAdd}
							icon={AddIcon}
							text={btn2Text}
							bg={"#3787FF"}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export const DetailsHeader = ({ text }) => {
  const navigate = useNavigate();
  return (
    <div className="h-32 w-full bg-white">
      <div className="section-container h-full flex gap-5 items-center">
        <FaChevronLeft
          onClick={() => navigate(-1)}
          className="cursor-pointer"
        />
        <h4 className="text-2xl font-bold text-[#2A2A2A]">{text}</h4>
      </div>
    </div>
  );
};

export default Header;
